import React from 'react';

// Labelled form control with an optional leading icon (phosphor component).
const FormField = ({ id, label, required, icon: Icon, children }) => (
  <div className="op-field">
    <label htmlFor={id}>
      {label}
      {required ? <span className="op-field__req"> *</span> : null}
    </label>
    <div className={`op-field__control${Icon ? ' op-field__control--icon' : ''}`}>
      {Icon ? <Icon className="op-field__icon" size={20} weight="duotone" /> : null}
      {children}
    </div>
  </div>
);

export default FormField;
